import { safeGet } from '../../core/utils/safe-get.js';
import {
  LINE_VARIANT,
  type RectDatapointInternal,
  type SeriesVariantType,
  type ShapeDatapointWithGapPolicy,
  type MapDatapoints,
} from '../types/xy-chart-internals.js';
import type {
  AreaDatapoint,
  BarDatapoint,
  DotDatapoint,
  LineDatapoint,
} from '../types/xy-chart.js';

/*
 * These functions check if a datapoint is valid for different purposes:
 * - isGapDatapointForDisplay: Used to filter out gap datapoints for any visual feature (selection, canvas draw, etc.).
 * - isValidDatapointForDownload: Used to determine if a datapoint should be included in data downloads (e.g.: csv), specifically for line series.
 */

export function isGapDatapointForDisplay<T extends ShapeDatapointWithGapPolicy>(
  datapointMetadataMap: MapDatapoints,
) {
  return (datapoint: T) => !safeGet(datapointMetadataMap, datapoint).isGap;
}

export const isValidDatapointForDownload = (metadata: MapDatapoints) => {
  return (
    type: SeriesVariantType,
    datapoint:
      | RectDatapointInternal
      | DotDatapoint
      | LineDatapoint
      | BarDatapoint
      | AreaDatapoint,
  ) => {
    return type !== LINE_VARIANT || !metadata.get(datapoint)?.isGap;
  };
};
